import _extends from '@babel/runtime/helpers/extends';
import React__default, { useRef, useState, useMemo } from 'react';
import styled, { css } from 'styled-components';
import { M as Modal } from '../Modal/Modal-D4CRIFlS.js';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { u as useIntl } from '../LocalModules/storm-ui-intl/dist/esm/3rdPartyModules/react-intl/lib/src/components/useIntl-BLE3wELi-CV9fXVbx.js';
import { u as useTaktId } from '../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { C as CloseButton } from '../Button/CloseButton/CloseButton-BkzgC3Ln.js';
import { K as KEYBOARD_KEYNAMES } from '../LocalModules/storm-ui-utils/dist/esm/keyboardKeynames-AmBipDtf-AmBipDtf.js';
import { T as Text } from '../Text/Text-DeOJEz6f.js';

const Pill = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40019350__sc-ipxb9j-0"
})(["display:flex;justify-content:space-between;align-items:center;gap:", ";border:", ";border-radius:", ";background:", ";padding-inline-start:", ";padding-inline-end:", ";padding-block-start:", ";padding-block-end:", ";font-size:", ";height:", ";:hover{border-color:", ";background-color:", ";}", " ", ""], ({
  theme
}) => theme.spacing.xxsmall.default, ({
  theme
}) => theme.selectableContainer.border.default, ({
  theme
}) => theme.border.radius.small, ({
  theme
}) => theme.selectableContainer.backgroundColor.default, ({
  theme
}) => theme.controls.paddingInline.medium.default, ({
  theme
}) => theme.controls.paddingInline.small.default, ({
  theme
}) => theme.controls.paddingBlock.small.default, ({
  theme
}) => theme.controls.paddingBlock.small.default, ({
  theme
}) => theme.font.text.xsmall.default, ({
  theme
}) => theme.chatBoxInput.attachment.height, ({
  theme
}) => theme.chatBoxInput.attachment.borderColor.hover, ({
  theme
}) => theme.chatBoxInput.attachment.backgroundColor.hover, ({
  $disabled
}) => $disabled && css(["border-color:", ";"], ({
  theme
}) => theme.chatBoxInput.attachment.borderColor.unavailable), isMobile(css(["gap:", ";"], ({
  theme
}) => theme.spacing.xxsmall.mobile)));
const TextWrapper = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40019350__sc-ipxb9j-1"
})(["display:flex;flex-direction:column;"]);
const FileText = /*#__PURE__*/styled(Text).withConfig({
  componentId: "sc-storm-ui-40019350__sc-ipxb9j-2"
})(["max-width:100px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"]);
const LargeImage = /*#__PURE__*/styled('img').withConfig({
  componentId: "sc-storm-ui-40019350__sc-ipxb9j-3"
})(["max-width:100%;height:auto;"]);
const Thumbnail = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40019350__sc-ipxb9j-4"
})(["display:flex;"]);
const SmallImage = /*#__PURE__*/styled('img').withConfig({
  componentId: "sc-storm-ui-40019350__sc-ipxb9j-5"
})(["white-space:nowrap;border-radius:", ";height:", ";width:", ";cursor:pointer;box-shadow:", " inset;"], ({
  theme
}) => theme.chatBoxInput.attachment.image.borderRadius, ({
  theme
}) => theme.chatBoxInput.attachment.image.height, ({
  theme
}) => theme.chatBoxInput.attachment.image.width, ({
  theme
}) => theme.chatBoxInput.attachment.image.innerShadow);
const AttachmentPill = ({
  attachment,
  onClose,
  disabled
}) => {
  const {
    formatMessage
  } = useIntl();
  const thumbnailRef = useRef(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const toggleModal = () => {
    setModalOpen(!isModalOpen);
  };
  const handleKeyDownImage = event => {
    if (event.key === KEYBOARD_KEYNAMES.ENTER) {
      toggleModal();
    }
  };
  const handleKeyDownIcon = event => {
    if (event.key === KEYBOARD_KEYNAMES.ENTER) {
      onClose === null || onClose === void 0 || onClose();
    }
  };
  const isImage = attachment.type.split('/').includes('image');
  const getImgUrl = useMemo(() => URL.createObjectURL(attachment), [attachment]);
  const splitFileName = attachment.name.split('.');
  const fileName = splitFileName.slice(0, splitFileName.length - 1).join('.');
  const fileExtension = splitFileName.pop();
  const {
    getDataTaktAttributes
  } = useTaktId({
    fallbackId: 'close-button'
  });
  return /*#__PURE__*/React__default.createElement(Pill, {
    $disabled: disabled
  }, isImage ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Modal, {
    isOpen: isModalOpen,
    onClose: toggleModal,
    toggleEl: thumbnailRef.current,
    padding: "xxxsmall"
  }, /*#__PURE__*/React__default.createElement(LargeImage, {
    alt: attachment.name,
    src: URL.createObjectURL(attachment)
  })), /*#__PURE__*/React__default.createElement(Thumbnail, {
    "aria-haspopup": "true",
    ref: thumbnailRef,
    tabIndex: 0,
    role: "button",
    onKeyDown: handleKeyDownImage,
    onClick: toggleModal
  }, /*#__PURE__*/React__default.createElement(SmallImage, {
    alt: formatMessage({
      id: 'thumbnail-alt'
    }, {
      attachment: attachment.name
    }),
    src: getImgUrl
  }))) : /*#__PURE__*/React__default.createElement(TextWrapper, null, /*#__PURE__*/React__default.createElement(FileText, {
    renderAs: "p"
  }, fileName), /*#__PURE__*/React__default.createElement(FileText, {
    renderAs: "p",
    size: "xsmall",
    color: "tertiary"
  }, fileExtension)), /*#__PURE__*/React__default.createElement(CloseButton, _extends({}, getDataTaktAttributes(), {
    id: attachment.name,
    variant: "transparent",
    tabIndex: 0,
    onClick: onClose,
    onKeyDown: handleKeyDownIcon,
    label: formatMessage({
      id: 'remove-attachment'
    }, {
      attachment: attachment.name
    })
  })));
};

export { AttachmentPill as A };
//# sourceMappingURL=AttachmentPill-BuXrkBio.js.map
